﻿export class Busy {
    static eventName() { return 'Busy'; }

    constructor(public $element?: JQuery) { }

    eventName = Busy.eventName;
}